// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1bHp2w7MC-ks7yvD3aAZLa{width:1.5rem;height:1.7rem}", "",{"version":3,"sources":["webpack://./resources/js/components/Icons/LocationIcon/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,YAAA,CACA,aACJ","sourcesContent":[".svg {\n    width: 1.5rem;\n    height: 1.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg": "_1bHp2w7MC-ks7yvD3aAZLa"
};
export default ___CSS_LOADER_EXPORT___;
